import React from "react";
import { PodcastEpisodeListLoaderTemplate } from "themes/administration/podcast/components";

const PodcastEpisodeListLoader = (props) => {
    return <PodcastEpisodeListLoaderTemplate {...props} />;
};

export default PodcastEpisodeListLoader;
